import { createContext, useContext, useEffect, useMemo, useState } from "react";
// import ShoppingCart from "../components/ShoppingCart";
// import ShoppingCart from "../components/ShoppingCart";

const VasCartContext = createContext({});

const initialCartItems = localStorage.getItem("vas-cart")
  ? JSON.parse(localStorage.getItem("vas-cart"))
  : [];

const initialDiscountType = localStorage.getItem("vas-dicount-type")
  ? localStorage.getItem("vas-dicount-type")
  : "";

const initialDiscountValue = localStorage.getItem("vas-dicount-value")
  ? localStorage.getItem("vas-dicount-value")
  : "";

const initialExemptVat = localStorage.getItem("vas-exempt-vat")
  ? localStorage.getItem("vas-exempt-vat")
  : false;

/** VAS cart only. Must match backend vas.service VAS_ITEMS_VAT_RATE. */
const VAS_ITEMS_VAT_RATE = 0.14;

const VasCartProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [cartItems, setCartItems] = useState(initialCartItems);
  const [discountType, setDiscountType] = useState(initialDiscountType);
  const [discountValue, setDiscountValue] = useState(initialDiscountValue);
  const [exemptVat, setExemptVat] = useState(initialExemptVat);

  useEffect(() => {
    localStorage.setItem("vas-cart", JSON.stringify(cartItems));
  }, [cartItems]);

  const openCart = () => {
    setIsOpen(true);
  };

  const closeCart = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    localStorage.setItem("vas-dicount-value", discountValue);
    calculateTotalPrice();
  }, [discountValue]);

  useEffect(() => {
    localStorage.setItem("vas-dicount-type", discountType);
    calculateTotalPrice();
  }, [discountType]);

  useEffect(() => {
    if (exemptVat === false) {
      localStorage.removeItem("vas-exempt-vat");
    } else {
      localStorage.setItem("vas-exempt-vat", exemptVat);
    }
    calculateTotalPrice();
  }, [exemptVat]);

  const calculateTotalPrice = () => {
    let subtotal = 0;
    let discountAmount = 0;
    let vat = 0;
    let total = 0;

    for (let i = 0; i < cartItems.length; i++) {
      subtotal += cartItems[i]?.price * cartItems[i]?.quantity;
    }

    if (discountValue > 0) {
      if (discountType === "percent") {
        const clampedPercent = Math.min(discountValue, 100);
        discountAmount = Math.ceil(((subtotal * clampedPercent) / 100).toFixed(2));
      } else {
        discountAmount = Math.ceil(+Number(discountValue).toFixed(2));
      }
    }

    discountAmount = Math.min(discountAmount, subtotal);

    const totalAfterDiscountAmount = subtotal - discountAmount;
    // Must match backend vas.service VAS_ITEMS_VAT_RATE (not global vatPercent)
    vat = exemptVat ? 0 : Math.ceil((totalAfterDiscountAmount * VAS_ITEMS_VAT_RATE).toFixed(2));

    total = totalAfterDiscountAmount + vat;

    return {
      subtotal,
      discountAmount,
      vat,
      total,
    };
  };

  const priceData = useMemo(() => {
    return calculateTotalPrice();
  }, [cartItems, discountValue, discountType, exemptVat]);

  const cartQuantity = cartItems.reduce((quantity, item) => item.quantity + quantity, 0);
  const getItemQuantity = (data) => {
    return cartItems.find((item) => item._id === data?._id)?.quantity || 0;
  };
  const increaseCartQuantity = (data) => {
    setCartItems((currItems) => {
      if (currItems.find((item) => item._id === data?._id) == null) {
        return [...currItems, { ...data, quantity: 1 }];
      } else {
        return currItems.map((item) => {
          if (item._id === data?._id) {
            return { ...item, quantity: item.quantity + 1 };
          } else {
            return item;
          }
        });
      }
    });
  };
  const decreaseCartQuantity = (data) => {
    setCartItems((currItems) => {
      if (currItems.find((item) => item._id === data?._id)?.quantity === 1) {
        return currItems.filter((item) => item._id !== data?._id);
      } else {
        return currItems.map((item) => {
          if (item._id === data?._id) {
            return { ...item, quantity: item.quantity - 1 };
          } else {
            return item;
          }
        });
      }
    });
  };
  const removeFromCart = (id) => {
    setCartItems((currItems) => currItems.filter((item) => item._id !== id));
  };
  const removeAllFromCart = () => {
    setCartItems([]);
    localStorage.removeItem("vas-cart");
    localStorage.removeItem("vas-dicount-value");
    localStorage.removeItem("vas-dicount-type");
    localStorage.removeItem("vas-exempt-vat");
    setDiscountType("");
    setDiscountValue("");
    setExemptVat(false);
  };

  const changeDiscountType = (type) => {
    setDiscountType(type);
  };

  const changeDiscountValue = (value) => {
    setDiscountValue(value);
  };

  return (
    <VasCartContext.Provider
      value={{
        cartItems,
        getItemQuantity,
        increaseCartQuantity,
        decreaseCartQuantity,
        removeFromCart,
        openCart,
        closeCart,
        removeAllFromCart,
        cartQuantity,
        discountType,
        discountValue,
        changeDiscountType,
        changeDiscountValue,
        exemptVat,
        setExemptVat,
        priceData,
      }}
    >
      {children}
      {/* <ShoppingCart isOpen={isOpen} closeCart={closeCart} /> */}
    </VasCartContext.Provider>
  );
};

export default VasCartProvider;
export const useVasCart = () => {
  return useContext(VasCartContext);
};
